<template functional>
  <input type="submit" value="submit" />
</template>

<script>
export default {
  name: 'Button',
};
</script>

<style scoped>
input {
  width: 106px;
  height: 36px;
  background-color: var(--dark);
  border: 1px solid var(--light);
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  font-size: 17px;
  line-height: 1.47059;
  font-weight: 400;
  letter-spacing: -0.022em;
  outline: 0 none;
}
</style>
